import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import './WelcomePage.css';
import imgPhotography  from './2.jpg';
import imgVideography  from './3.jpg';
import imgLiveStream   from './1.jpg';
import imgWebDesign    from './4.jpg';

const services = [
  {
    label: 'Photography',
    desc: 'Capture timeless moments with stunning detail and artistic vision.',
    img: imgPhotography,
  },
  {
    label: 'Videography',
    desc: 'Cinematic video coverage that tells your story beautifully.',
    img: imgVideography,
  },
  {
    label: 'Live Streaming',
    desc: 'Broadcast your event live to audiences anywhere in the world.',
    img: imgLiveStream,
  },
  {
    label: 'Web Design',
    desc: 'Modern, responsive websites crafted to elevate your brand online.',
    img: imgWebDesign,
  },
];

const cyclingWords = ['Photography', 'Videography', 'Live Streaming', 'Web Design'];

export default function WelcomePage() {
  const navigate = useNavigate();
  const [wordIndex, setWordIndex] = useState(0);
  const [animating, setAnimating] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setAnimating(true);
      setTimeout(() => {
        setWordIndex(prev => (prev + 1) % cyclingWords.length);
        setAnimating(false);
      }, 400);
    }, 2400);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="welcome-root">
      {/* Dark BG image with maroon/yellow overlay */}
      <div className="bg-image" />
      <div className="bg-overlay" />

      {/* Soft yellow full-screen continuous animation */}
      <div className="yellow-glow-anchor">
        {/* Orbs */}
        <div className="yellow-orb orb-main" />
        <div className="yellow-orb orb-ring-1" />
        <div className="yellow-orb orb-ring-2" />
        <div className="yellow-orb orb-br" />
        <div className="yellow-orb orb-cr" />
        <div className="yellow-orb orb-bl" />
        <div className="yellow-orb orb-tc" />
        {/* Particles */}
        {Array.from({ length: 20 }).map((_, i) => (
          <div key={i} className={`yellow-particle p${i + 1}`} />
        ))}
        {/* Streaks */}
        {Array.from({ length: 8 }).map((_, i) => (
          <div key={i} className={`yellow-streak s${i + 1}`} />
        ))}
      </div>

      {/* Film strip decorations */}
      <div className="film-strip film-left">
        {Array.from({ length: 14 }).map((_, i) => <div key={i} className="film-hole" />)}
      </div>
      <div className="film-strip film-right">
        {Array.from({ length: 14 }).map((_, i) => <div key={i} className="film-hole" />)}
      </div>

      <div className="welcome-inner">

        {/* Badge */}
        <div className="badge fade-up delay-1">
          <span className="badge-dot" />
          Professional Media Services
        </div>

        {/* Headline */}
        <h1 className="headline fade-up delay-2">
          We Deliver
          <br />
          <span className="cycling-wrapper">
            <span className={`cycling-word ${animating ? 'exit' : 'enter'}`}>
              {cyclingWords[wordIndex]}
            </span>
          </span>
        </h1>

        <p className="subtitle fade-up delay-3">
          Book world-class media professionals for every occasion —
          <br />from intimate ceremonies to grand-scale productions.
        </p>

        {/* Service Cards */}
        <div className="cards fade-up delay-4">
          {services.map(({ img, label, desc }, i) => (
            <div className="card" key={label} style={{ '--i': i }}>
              <div className="card-img-wrap">
                <img src={img} alt={label} className="card-img" />
                <div className="card-img-overlay" />
                <span className="card-number">0{i + 1}</span>
              </div>
              <div className="card-body">
                <h3 className="card-label">{label}</h3>
                <p className="card-desc">{desc}</p>
                <div className="card-accent-bar" />
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <button
          className="cta-btn fade-up delay-5"
          onClick={() => navigate('/book')}
        >
          <span>Let's Start</span>
          <div className="btn-icon">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" strokeWidth="2.5"
              strokeLinecap="round" strokeLinejoin="round">
              <path d="M5 12h14M12 5l7 7-7 7" />
            </svg>
          </div>
        </button>

        
      </div>
    </div>
  );
}